import { Link, useRouterState } from '@tanstack/react-router';
import {
  Bot,
  Building2,
  Link2,
  Megaphone,
  PackageOpen,
  ScrollText,
  Users,
  Warehouse,
} from 'lucide-react';
import type { ComponentType } from 'react';

import { cn } from '@/lib/cn';

interface NavItem {
  icon: ComponentType<{ className?: string }>;
  label: string;
  to: string;
}

const NAV_ITEMS: readonly NavItem[] = [
  { icon: Bot, label: 'Аккаунты', to: '/accounts' },
  { icon: Users, label: 'Клиенты', to: '/clients' },
  { icon: Warehouse, label: 'Склады', to: '/warehouses' },
  { icon: Link2, label: 'Trade-links', to: '/trade-links' },
  { icon: Megaphone, label: 'Кампании', to: '/campaigns' },
  { icon: PackageOpen, label: 'Пополнение', to: '/replenishment' },
  { icon: ScrollText, label: 'Аудит', to: '/audit' },
  { icon: Building2, label: 'Пользователи', to: '/users' },
];

const isActive = (pathname: string, to: string): boolean => {
  if (to === '/') return pathname === '/';
  return pathname === to || pathname.startsWith(`${to}/`);
};

export const Sidebar = () => {
  const pathname = useRouterState({ select: (state) => state.location.pathname });

  return (
    <aside className="w-56 shrink-0 border-r border-border p-4">
      <Link to="/" className="block px-2 pb-4 text-lg font-semibold">
        SteamBlast
      </Link>
      <nav aria-label="Навигация" className="space-y-1">
        {NAV_ITEMS.map((item) => {
          const active = isActive(pathname, item.to);
          return (
            <Link
              key={item.to}
              to={item.to}
              className={cn(
                'flex items-center gap-2 rounded px-2 py-1.5 text-sm transition-colors',
                active
                  ? 'bg-accent text-accent-foreground'
                  : 'text-muted-foreground hover:bg-accent/50 hover:text-foreground',
              )}
            >
              <item.icon className="h-4 w-4" />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>
    </aside>
  );
};
